"use client";

import Image from "next/image";
import { useState } from "react";

/**
 * The infinity logo with its purple drop-shadow glow.
 *
 * The drop-shadow is applied only AFTER the PNG has decoded. Before decode,
 * `filter: drop-shadow()` has no alpha shape to follow and falls back to the
 * element's bounding box — rendering a glowing rectangle ("kasten") behind the
 * logo until the next repaint. Gating the filter on load avoids that flash.
 */
export default function HeroLogo() {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className="relative mx-auto flex w-full max-w-xs items-center justify-center lg:max-w-none">
      <div
        aria-hidden
        className="absolute inset-0 -z-10 rounded-full lg:hidden"
        style={{
          background:
            "radial-gradient(closest-side, rgba(168,85,247,0.28), transparent 75%)",
        }}
      />
      <Image
        src="/logo-infinity-symbol.webp"
        alt="Infinity City Logo"
        width={440}
        height={240}
        sizes="(min-width: 1024px) 440px, 250px"
        priority
        onLoad={() => setLoaded(true)}
        className={`h-auto w-[78%] max-w-[400px] animate-float-soft lg:w-full ${
          loaded ? "drop-shadow-[0_10px_44px_rgba(168,85,247,0.5)]" : ""
        }`}
      />
    </div>
  );
}
